import { SearchItem } from '@yiluhub/yilu-amp-types';

import { extractAmpProductAttribute } from 'utils/ampUtils';

export function isLoungeLocked(searchItem: SearchItem) {
  //visible is a LHG specific attribute
  const visibleAttr = extractAmpProductAttribute(searchItem, 'visible');
  let isLocked = false;

  if (visibleAttr !== undefined) {
    isLocked = visibleAttr === 'false';
  }

  return isLocked;
}

export function isLoungeBookable(searchItem: SearchItem) {
  let isBookable = true;
  //isBookable is a LHG specific attribute
  const isBookableAttr = extractAmpProductAttribute(searchItem, 'isBookable');

  if (isBookableAttr !== undefined) {
    isBookable = isBookableAttr === 'true';
  }

  return isBookable;
}
